import {
  healthResponseSchema,
  type HealthResponse,
} from '@questaurant/lib-shared';
import { get } from './http';

/**
 * Health domain module (frontend design §6.1). The response is parsed with the
 * shared zod schema, so a contract drift shows up here rather than as a blank
 * badge.
 */
export async function getHealth(signal?: AbortSignal): Promise<HealthResponse> {
  const body = await get<unknown>('/api/healthz', { signal });
  return healthResponseSchema.parse(body);
}
